{
  "pdf": [
    {
      "id": "1",
      "name": {
        "EN": "20210105_DNI_FoT_Newspaper Articles_negative manipulation_vf.pdf",
        "DE": "20210105_DNI_FoT_Newspaper Articles_negative manipulation_vf_de.pdf",
        "JP": "20210105_DNI_FoT_Newspaper Articles_negative manipulation_vf_de.pdf"
      },
      "description": "Negative Manipulation Article",
      "placeholder": "future of trust",
      "scope": "test"
    },
    {
      "id": "2",
      "name": {
        "EN": "20210105_DNI_FoT_Newspaper Articles_positive manipulation_vf.pdf",
        "DE": "20210105_DNI_FoT_Newspaper Articles_positive manipulation_vf_de.pdf",
        "JP": "20210105_DNI_FoT_Newspaper Articles_positive manipulation_vf_de.pdf"
      },
      "description": "Positive Manipulation Article",
      "placeholder": "future of trust",
      "scope": "block"
    },
    {
      "id": "3",
      "name": {
        "EN": "20210105_DNI_FoT_Newspaper Articles_positive manipulation_vf.pdf",
        "DE": "20210105_DNI_FoT_Newspaper Articles_positive manipulation_vf_de.pdf",
        "JP": "20210105_DNI_FoT_Newspaper Articles_positive manipulation_vf_de.pdf"
      },
      "description": "Positive Manipulation Article",
      "placeholder": "future of trust",
      "scope": "test"
    },
    {
      "id": "5",
      "name": {
        "EN": "20210105_DNI_FoT_Newspaper Articles_negative manipulation_vf.pdf",
        "DE": "20210105_DNI_FoT_Newspaper Articles_negative manipulation_vf_de.pdf",
        "JP": "20210105_DNI_FoT_Newspaper Articles_negative manipulation_vf_de.pdf"
      },
      "description": "Negative Manipulation Article",
      "placeholder": "test",
      "scope": "block"
    },
    {
      "id": "4",
      "name": "",
      "description": "Empty",
      "placeholder": "future of trust",
      "scope": "block"
    },
    {
      "id": "6",
      "name": {
        "EN": "vscode-shortcuts-macos.pdf",
        "DE": "vscode-shortcuts-macos_de.pdf",
        "JP": "vscode-shortcuts-macos_de.pdf"
      },
      "description": "VS Code",
      "placeholder": "test",
      "scope": "test"
    }
  ]
}
